module.exports = __webpack_public_path__ + "img/face-confounded.91cf7297.svg";